import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import AdminResourceManagementTable from '../../../../../../shared/components/formComponents/AdminResourceManagementTable';
import { TEAM_RESOURCE_PERMISSION_TYPES } from '../../../../../../shared/Constants';

export default class CompanyTeamResources extends PureComponent {
    static propTypes = {
        currentValues: PropTypes.object,
        isAccountOwner: PropTypes.bool,
        isContentAdmin: PropTypes.bool,
        isVerbAdmin: PropTypes.bool,
        mediaMetadata: PropTypes.array,
        team: PropTypes.object
    };

    render() {
        const { currentValues, isAccountOwner, isContentAdmin, isVerbAdmin, mediaMetadata, team } = this.props;

        return (
            <div className={'team-content-section-container col-12 col-sm-10'}>
                {(isVerbAdmin || isAccountOwner) && (
                    <div className={'col-10'}>
                        <FieldArray
                            name={'resources'}
                            label={'Team Resources'}
                            className={'col-4'}
                            mediaMetadata={mediaMetadata}
                            currentValues={currentValues}
                            component={AdminResourceManagementTable}
                            team={team}
                            RESOURCE_PERMISSION_TYPES={TEAM_RESOURCE_PERMISSION_TYPES}
                            resourcesParentType={'teams'}
                            isVerbAdmin={isVerbAdmin}
                            isContentAdmin={isContentAdmin}
                            isAccountOwner={isAccountOwner}
                        />
                    </div>
                )}
            </div>
        );
    }
}
